module.exports = __webpack_public_path__ + "static/media/wiggle.4199c218.svg";